import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FusePageCarded, FuseAnimateGroup } from '@fuse';
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Button, Tab, Tabs, Icon, IconButton, TextField, Grid, Tooltip } from '@material-ui/core';
import * as Actions from './store/actions';
import ReactTable from "react-table";
import * as TableActions from 'main/components/tableSort/store/actions';
import _ from 'lodash';
import TabPanelButtons from '../../components/TabPanelButtons';

const styles = theme => ({
    layoutRoot   : {},
    layoutToolbar: {
        padding: 0
    },
    tabsRoot     : {
        height: 64,
        flex:   1,
    },
    tabRoot      : {
        height: 64
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
    },
    textFieldSearch: {
        marginLeft: theme.spacing.unit,
        width: '95%',
    },
    button: {
        margin: theme.spacing.unit,
    },
    root: {
        flexGrow: 1,
    },
});

class EventStudentList extends Component {
    state = {
        current_tab:   0,
        event_id: 0,
    }

    constructor(props) {
        super(props);

        const event_id = this.props.match.params.event_id;

        this.state = {
            ...this.state,
            event_id: event_id,
        }
    }

    componentDidMount = () => {
        this.props.getEventStudentList(this.state.event_id);
        this.props.getEventInfo(this.state.event_id);
    }

    handleRowClick = (student_info) => {
        const { student_quiz_id, student_assignment_id, quiz_id, assignment_id } = student_info;

        if(student_quiz_id) {
            this.props.history.push(`/quiz/grader/${student_quiz_id}`);
        } else if(student_assignment_id) {
            this.props.history.push(`/assignment/grader/${student_assignment_id}`);
        }
    }

    getGradeStatus = (student_info) => {
        if(!student_info.student_quiz_id && !student_info.student_assignment_id) {
            return "Not Submitted";
        }

        if(student_info.EventIsGraded) {
            return "Graded";
        }

        return "Ungraded";
    }

    handleScoreChange = gradebook_detail_id => event => {
        let value = event.target.value;

        this.props.updateGradebookScore(gradebook_detail_id, value);
    }

    handleScoreBlur = gradebook_detail_id => event => {
        let value = Number(event.target.value);
        if (isNaN(value)) {
            value = Number(0.00).toFixed(1);
        } else {
            value = Math.abs(value).toFixed(1)
        }

        this.props.updateGradebookScore(gradebook_detail_id, value);
        this.props.saveGradebookScore(gradebook_detail_id, value);
    }

    getPageContent = (current_tab) => {
        const { classes, eventStudentList, event_info, table_sort, table_filter, table_page_size, is_loaded } = this.props;
        const table_name = this.constructor.name;

        if (!is_loaded) return <React.Fragment>Loading...</React.Fragment>;

        switch(current_tab)
        {
            case(0): // Student List
            {
                return (
                    <ReactTable
                        style={{ position: 'absolute' }}
                        columns={[
                            {
                                Header: "Student Name",
                                accessor: "StudentName"
                            },
                            {
                                Header: "Event Score",
                                Cell: (row) => (
                                    Number(row.original.EventScore).toFixed(1) + ' / ' + Number(row.original.EventTotalScore).toFixed(1)
                                )
                            },
                            {
                                Header: "Final Grade",
                                Cell: (row) => (
                                    <TextField
                                        id          = "GradebookScore"
                                        value       = {Number(row.original.GradebookScore).toFixed(1)}
                                        onChange    = {this.handleScoreChange(row.original.gradebook_detail_id)}
                                        onBlur      = {this.handleScoreBlur(row.original.gradebook_detail_id)}
                                        margin      = "normal"
                                        variant     = "outlined"
                                        type        = "number"
                                        margin      = "dense"
                                        inputProps  = {{ min: 0.00, step: 1 }}
                                    />
                                )
                            },
                            {
                                Header: "Status",
                                accessor: "EventStatus"
                            },
                            {
                                Header: "Grade",
                                Cell: (row) => (
                                    <IconButton
                                        style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
                                        onClick={(ev) => {
                                            ev.stopPropagation();
                                            this.handleRowClick(row.original);
                                        }}
                                        disabled={ !(row.original.student_assignment_id > 0 || row.original.student_quiz_id > 0) }
                                    >
                                        <Icon>assignment</Icon>
                                    </IconButton>
                                )
                            }
                        ]}
                        data={eventStudentList}
                        defaultPageSize={25}
                        pageSize={table_page_size[table_name]}
                        className="-striped -highlight"
                        noDataText="No Students Found"
                        defaultSorted={table_sort[table_name]}
                        onSortedChange={(sort_list) => this.props.setTableSort(this.props.auth.user.data.auth_id, table_name, sort_list)}
                        filterable={true}
                        defaultFiltered={table_filter[table_name]}
                        onFilteredChange={_.debounce((filter_list) => this.props.setTableFilter(this.props.auth.user.data.auth_id, table_name, filter_list), 500)}
                        onPageSizeChange={(page_size) => this.props.setTablePageSize(this.props.auth.user.data.auth_id, table_name, page_size)}
                    />
                )
            }

            case(1): // Statistics
            {
                return (
                    <div className="p-24">
                        <Grid container>
                            <Grid item xs={6}>
                                <Grid container>
                                    <Grid item xs={12}>
                                        <TextField
                                            label      = "Event Name"
                                            value      = {event_info.EventName}
                                            margin     = "normal"
                                            variant    = "outlined"
                                            disabled   = "true"
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            label      = "Event Date"
                                            value      = {event_info.EventDate}
                                            margin     = "normal"
                                            variant    = "outlined"
                                            disabled   = "true"
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            label      = "Event Start Time"
                                            value      = {event_info.StartTime}
                                            margin     = "normal"
                                            variant    = "outlined"
                                            disabled   = "true"
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            label      = "Event End Time"
                                            value      = {event_info.EndTime}
                                            margin     = "normal"
                                            variant    = "outlined"
                                            disabled   = "true"
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            label      = "Course"
                                            value      = {event_info.CourseName}
                                            margin     = "normal"
                                            variant    = "outlined"
                                            disabled   = "true"
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            label      = "Lesson"
                                            value      = {event_info.LessonName}
                                            margin     = "normal"
                                            variant    = "outlined"
                                            disabled   = "true"
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            label      = "Event Type"
                                            value      = {event_info.EventType}
                                            margin     = "normal"
                                            variant    = "outlined"
                                            disabled   = "true"
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </div>
                );
            }

            default:
            {
                return <React.Fragment>Error: No tab found.</React.Fragment>
            }
        }
    }

    handleChangeTab = (event, value) => {
        this.setState({
            ...this.state,
            current_tab: value
        });
    }

    render() {
        const { classes, event_name, course_name } = this.props;
        const { current_tab}          = this.state;
        const page_content            = this.getPageContent(current_tab);

        return (
            <FusePageCarded
                classes={{
                    root:    classes.layoutRoot,
                    toolbar: classes.layoutToolbar
                }}
                header={
                    <div className="py-24">
                        <h4>
                            {"Gradebook"}
                        </h4>
                        <h4>
                            Course Name: {course_name}
                        </h4>
                        <h4>
                            Event Name: {event_name}
                        </h4>
                    </div>
                }
                contentToolbar={
                    <div style={{ width: '100%', height: '100%' }}>
                        <Grid container>
                            <Tabs
                                value={current_tab}
                                onChange={this.handleChangeTab}
                                indicatorColor="primary"
                                textColor="primary"
                                classes={{
                                    root: classes.tabsRoot
                                }}
                            >
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Student List"
                                />
                                {/* <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Statistics"
                                /> */}
                            </Tabs>
                            <TabPanelButtons
                                component_name={"assignment"}
                                view_type={"edit"}
                                button_list={[
                                    {
                                        type: "back",
                                        onClick: () => this.props.history.goBack(),
                                    }
                                ]}
                            />
                        </ Grid>
                    </div>
                }
                content={page_content}
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getEventStudentList:            Actions.getEventStudentList,
        generateBlankStudentSubmission: Actions.generateBlankStudentSubmission,
        updateGradebookScore:           Actions.updateGradebookScore,
        saveGradebookScore:             Actions.saveGradebookScore,
        getEventInfo:                   Actions.getEventInfo,
        setTableSort:                   TableActions.setTableSort,
        setTableFilter:                 TableActions.setTableFilter,
        setTablePageSize:               TableActions.setTablePageSize,
    }, dispatch);
}

function mapStateToProps({ gradebookApp, tableSort, auth }) {
    return {
        eventStudentList: gradebookApp.gradebook.eventStudentList,
        event_name:       gradebookApp.gradebook.event_name,
        course_name:      gradebookApp.gradebook.course_name,
        event_info:       gradebookApp.gradebook.event_info,
        table_sort:       tableSort.table_sort,
        table_filter:     tableSort.table_filter,
        table_page_size:  tableSort.table_page_size,
        is_loaded:        tableSort.is_loaded,
        auth
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(EventStudentList)));



// WEBPACK FOOTER //
// src/main/content/gradebook/EventStudentList.js